<template>
    <b-form>
        <b-form-group
            label="Patient:"
            :label-cols="labelCols"
            label-for="type"
            v-if="data.module !== 'hover'"
        >
            <p class="plain-text" id="type">
                <a :href="data.patient.ci_url">{{ data.patient.name }}</a>
            </p>
        </b-form-group>
        <b-form-group label="Type:" :label-cols="labelCols" label-for="type">
            <p
                class="plain-text"
                id="type"
                v-if="data.treatment_activity_type_id !== 3"
            >
                {{ TREATMENT_TYPE[data.treatment_activity_type_id] }}
            </p>
            <p class="plain-text" id="type" v-else>
                {{ other.label }}
            </p>
        </b-form-group>
        <b-form-group
            v-if="data.treatment_activity_type_id === 1"
            :label-for="`item_id`"
            :label-cols="labelCols"
            label="Medication:"
        >
            <a
                v-for="(data, i) in result"
                :key="i"
                :href="itemUrl(data)"
                class="plain-text"
                id="type"
                >{{ data.item.name ? data.item.name : data.name }}</a
            >
        </b-form-group>
        <b-form-group
            v-if="data.treatment_activity_type_id == 1 && !data.isLab"
            :label-for="`quantity`"
            :label-cols="labelCols"
            label="Quantity:"
        >
            <div class="form-inline">
                <span class="plain-text" id="type"
                    >{{ result.length > 0 ? result[0].quantity : "" }}
                    {{
                        result.length > 0 ? result[0].item_uom.value : "Unit(s)"
                    }}</span
                >
            </div>
        </b-form-group>
        <b-form-group
            v-if="data.treatment_activity_type_id == 1 && !data.isLab"
            :label-for="`route`"
            :label-cols="labelCols"
            label="Route:"
        >
            <p class="plain-text" id="type">
                {{ route ? route.value : "None" }}
            </p>
        </b-form-group>
        <b-form-group
            v-if="data.treatment_activity_type_id == 1 && !data.isLab"
            :label-for="`location`"
            :label-cols="labelCols"
            label="Location:"
        >
            <p class="plain-text" id="type">
                {{ location ? location.value : "None" }}
            </p>
        </b-form-group>
        <b-form-group
            v-if="note"
            :label-for="`notes`"
            :label-cols="labelCols"
            label="Notes:"
        >
            <p class="plain-text" id="type">
                {{ note }}
            </p>
        </b-form-group>
        <b-form-group
            v-if="
                data.treatment_activity_type_id == 1 &&
                record.soap &&
                record.soap.label
            "
            :label-for="`medicalNote`"
            :label-cols="labelCols"
            label="Medical Note:"
        >
            <a
                :href="'../apps/' + record.soap.ci_url"
                class="plain-text"
                id="type"
                >{{ record && record.soap ? record.soap.label : "" }}</a
            >
        </b-form-group>
        <b-form-group
            v-if="
                data.treatment_activity_type_id == 1 &&
                record.invoice_item &&
                record.invoice_item.invoice.name != undefined
            "
            :label-for="`invoice`"
            :label-cols="labelCols"
            label="Invoice:"
        >
            <a
                class="plain-text"
                id="type"
                :href="
                    '../apps/billing/invoice/view/' +
                    record.invoice_item.invoice.encoded_id
                "
                >{{
                    record && record.invoice_item
                        ? record.invoice_item.invoice.name
                        : "None"
                }}</a
            >
        </b-form-group>
        <b-form-group
            :key="vital.id"
            v-for="vital in vitals"
            :label-for="`vital`"
            :label-cols="labelCols"
            :label="vital.master_vital + ':'"
        >
            <p class="plain-text" id="type">
                {{ vital.value + " " + vital.master_uom }}
            </p>
        </b-form-group>
        <b-form-group
            v-if="_.some(data.treatment_vitals)"
            :label-for="`units`"
            :label-cols="labelCols"
            label="Vital:"
        >
            <p class="plain-text" id="type">
                {{ unitVitals }}
            </p>
        </b-form-group>
        <b-form-group
            v-if="_.some(data.treatment_vitals) && vitals.vitalNote"
            :label-for="`notes`"
            :label-cols="labelCols"
            label="Notes:"
        >
            <p class="plain-text" id="type">
                {{ vitals.vitalNote }}
            </p>
        </b-form-group>
        <b-form-group
            v-if="data.treatment_activity_type_id == 3 && other.task"
            label="Notes:"
            :label-cols="labelCols"
            label-for="notes"
        >
            <p class="plain-text" id="type">{{ other.task }}</p>
        </b-form-group>
        <!-- Complete By/At section-->
        <b-form-group
            v-if="data.complete_at"
            label="Completed By:"
            :label-cols="labelCols"
            :label-for="`completedAt`"
        >
            <p class="plain-text" id="type">
                {{
                    data && staff
                        ? staff.fullname +
                          " at " +
                          _toDateTime(data.complete_at).toFormat(
                              _dateFormat + "  hh:mm a"
                          )
                        : ""
                }}
            </p>
        </b-form-group>
    </b-form>
</template>
<script>
import ScheduleHelper from "../helper";
import { merge, find } from "lodash";

export default {
    name: "ActivitySummaryList",
    components: {},
    data() {
        return {
            data: {
                patient: {
                    ci_url: null
                },
                treatment_vitals: null,
                complete_at: null,
                treatment_activity_type_id: null,
                isLab: false
            },
            record: {
                item: {
                    id: null,
                    name: null
                },
                soap: {
                    label: null,
                    encoded_id: null
                },
                itemUom: {
                    label: null
                },
                quantity: "",
                invoice_item: {
                    item: {
                        encoded_id: null
                    },
                    invoice: {
                        extended: {
                            encoded_id: null
                        }
                    }
                }
            },
            vitals: [],
            other: [],
            staff: null,
            route: null,
            location: null,
            note: null,
            rooms: [],
            staffList: [],
            result: []
        };
    },
    props: {
        params: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    mixins: [ScheduleHelper],
    computed: {
        labelOptions() {
            return this.$store.state.reference["treatment-task-label"];
        },
        labelCols() {
            return this.data && this.data.complete_at ? 4 : 3;
        },
        unitVitals() {
            return this.data.treatment_vitals
                .map(vital => vital.master_vital.vital)
                .join(", ");
        }
    },
    mounted() {
        this.open(this.params);
    },
    methods: {
        open(params) {
            let self = this;
            merge(this.data, params);
            this.$emit("loading");
            if (this.data.complete_by) {
                this.getStaff(this.data.complete_by).then(staff => {
                    self.staff = staff;
                });
            }

            return this.getActivity(params.id)
                .then(activity => {
                    this.data = merge(this.data, activity);
                    if (this.data.treatment_activity_type_id === 1) {
                        self.note = this.data.note;
                        return this.getRecord(this.data);
                    } else if (this.data.treatment_activity_type_id === 2) {
                        return this.getVitals(this.data);
                    } else if (this.data.treatment_activity_type_id === 3) {
                        if (self.data.other_tasks.length) {
                            self.other = self.data.other_tasks[0];
                            let labelId = self.other.label_id
                                ? self.other.label_id
                                : 1;
                            _.forEach(self.labelOptions, function (option) {
                                if (option.value === labelId) {
                                    self.other = merge(self.other, {
                                        label: option.text
                                    });
                                }
                            });
                        }
                    }
                })
                .finally(() => {
                    this.$emit("loaded");
                });
        },
        getActivity(id) {
            return this.$http
                .get(process.env.BARRACUDA + "schedule/activity/" + id)
                .then(response => {
                    return response.data.response.resources;
                });
        },
        getRecord(data) {
            let records = [];
            let self = this;
            if (data.treatment_activity_type_id === 1) {
                records = this.data.medications;
                self.data.isLab = true;
                if (this.data.complete_by) {
                    _.forEach(records, function (record) {
                        self.$http
                            .get(
                                process.env.BARRACUDA +
                                    "record/medical-record/" +
                                    record.record_id
                            )
                            .then(response => {
                                if (
                                    response.data.response.resource.item
                                        .item_type.id !== 7
                                ) {
                                    self.data.isLab = false;
                                    self.route = find(
                                        self.$store.state.reference[
                                            "master-vaccination-route"
                                        ],
                                        {
                                            id: record.route_id
                                        }
                                    );
                                    self.location = find(
                                        self.$store.state.reference[
                                            "master-vaccination-location"
                                        ],
                                        {
                                            id: record.location_id
                                        }
                                    );
                                }
                                self.result.push(
                                    response.data.response.resource
                                );
                            });
                    });
                    return self.result;
                } else {
                    _.forEach(records, function (record) {
                        self.getInventoryItem(record.item_id).then(response => {
                            if (response.itemType.id !== 7) {
                                self.data.isLab = false;
                                self.record.quantity = record.quantity;
                                self.record.itemUom = response.itemUom;
                                self.route = find(
                                    self.$store.state.reference[
                                        "master-vaccination-route"
                                    ],
                                    {
                                        id: record.route_id
                                    }
                                );
                                self.location = find(
                                    self.$store.state.reference[
                                        "master-vaccination-location"
                                    ],
                                    {
                                        id: record.location_id
                                    }
                                );
                            }
                            self.result.push(
                                merge(_.clone(self.record), response)
                            );
                            self.result = self.result = _.map(
                                self.result,
                                item => ({
                                    ...item,
                                    item_uom: {
                                        id: item.itemUom.id,
                                        value: item.itemUom.label
                                    }
                                })
                            );
                        });
                    });
                }
            }
        },
        getVitals(data) {
            let self = this;
            if (data.treatment_activity_type_id === 2) {
                self.vitals.vitalNote = data.note;
                _.forEach(data.vitals, function (vital) {
                    self.vitals.push({
                        id: vital.id,
                        value: vital.value,
                        master_vital: vital.master_vital.vital,
                        master_uom: vital.master_uom.uom
                    });
                });
            }
        },
        getInventoryItem(id) {
            return this.$http
                .get(process.env.BARRACUDA + "inventory/" + id)
                .then(response => {
                    return response.data.response.resources;
                });
        },
        getStaff(id) {
            return this.$http
                .get(process.env.BARRACUDA + "actor/staff/" + id)
                .then(response => {
                    return response.data.response.resource.actor;
                });
        },
        itemUrl(data) {
            let url = "";
            if (data.item.id) {
                if (data.item.item_type.id === 7) {
                    url =
                        process.env.APPS +
                        "index.php/patient/lab/view/" +
                        data.patient.id +
                        "/" +
                        data.id;
                } else {
                    url = "../apps/inventory/item/view/" + data.item.encoded_id;
                }
            } else {
                url = "../apps/inventory/item/view/" + data.encoded_id;
            }
            return url;
        }
    }
};
</script>
